import BatchMonthExportDialog from '@/views/billManage/billList/components/BatchMonthExportDialog.vue';

/**
 * 账单列表批量按月份范围导出。
 * 组件需实现 handleExport(options)，支持：
 * { Month_start, Month_end, forceAll: true }
 */
export default {
  components: {
    BatchMonthExportDialog,
  },
  data() {
    return {
      showBatchExportDialog: false,
      batchExportLoading: false,
    };
  },
  methods: {
    openBatchExportDialog() {
      this.showBatchExportDialog = true;
    },
    async onBatchMonthExportConfirm({ Month_start, Month_end }) {
      this.batchExportLoading = true;
      try {
        await this.handleExport({
          Month_start,
          Month_end,
          forceAll: true,
        });
        this.showBatchExportDialog = false;
      } catch (error) {
        console.error('批量导出错误:', error);
      } finally {
        this.batchExportLoading = false;
      }
    },
  },
};
